import { TransactionType } from "@interfaces/transaction"
import { getAppFeatures } from "@utils/getAppFeatures"

const transactionsAllowed = getAppFeatures()?.features?.transactionsAllowed

export const getFiltersById = <T extends { id: string }>(value: T): boolean =>
    transactionsAllowed.includes(value.id as TransactionType)

export const getOrderFilterById = <T extends { id: string }>(value: T): boolean =>
    value?.id == 'MARKET' || value?.id == 'LIMIT' || transactionsAllowed.includes(value.id as TransactionType)

export const filterByTransactionType = <T extends { type: TransactionType }>(item: T): boolean =>
    transactionsAllowed.includes(item.type)
